import clsx from 'clsx'
import { ClassName } from 'types/props'

import classes from './index.module.scss'

export const Rule = ({ className }: ClassName) => <hr className={clsx(className, classes.root)} />
